import { getDisplayNameEng, isEmpty } from "../../../utils/helpers";
import { env } from "../../../config/variable-config";
import { endpointConfig } from "../../../config/api-config";
import { Linking, Platform } from "react-native";

export const getCcTopicContactString = topic => {
  const memberId = topic.creatorMemberId;
  const member =
    Array.isArray(topic.members) && topic.members.find(m => m.id === memberId);
  const profile = member && member.profile && member.profile.data;
  if (isEmpty(profile)) return "";
  return getDisplayNameEng(profile);
};

export const isSnSOrAdmin = user => user && user.isSa;

// export const isSnSOrAdmin = user => user &&
// (user.userName === "steve" ||
//   user.userName === "lucy" ||
//   user.userName === "felix" ||
//   user.userName === "happy" ||
//   user.userName === "happy5" ||
//   user.userName === "happy8" ||
//   user.userName === "happy10" ||
//   user.userName === "leonli" ||
//   user.userName === "liang" ||
//   user.userName === "stephanie");

export const isDevAdmin = user =>
  user &&
  (user.userName === "felix" ||
    user.userName === "happy" ||
    user.userName === "happy5" ||
    user.userName === "happy8" ||
    user.userName === "happy10" ||
    user.userName === "leonli" ||
    user.userName === "urmandke18" ||
    user.userName === "urmandke25" ||
    user.userName === "liang" ||
    user.isSa);

export const is3FreePromo = promo =>
  !isEmpty(promo) && promo.id >= 19 && promo.id <= 33;

export const FCFilter = g =>
  env !== "prod" ||
  (g.member &&
    g.member.email &&
    !g.member.email.match(/(kefelan.com|kitsilanofc.com)/g));

export const openCAF = () => {
  const url = window.location.hostname === "devapp.mycarebase.com"
    ? `${window.location.origin}/find/senior-caregiver`
    : `https://${endpointConfig.wp_hostname}/finder`;
  if (Platform.OS === "web") {
    return window.open(url);
  } else {
    return Linking.openURL(url);
  }
};

export const minimizeString = input =>
  input
    ? input
        .toLowerCase()
        .replace(/[^a-z0-9]/gi, "")
        .trim()
    : "";

/**
 * Check if all caregiver onboarding steps are completed (JavaScript version).
 * Portable: does not reference any RN components; relies only on provided data.
 */
export const isCaregiverOnboardingCompleted = onboardingDataSet => {
  if (!onboardingDataSet) return false;
  const { profileData = {}, onboarding = {}, onboardingUpload = {} } =
    onboardingDataSet || {};
  const isPointerpro = !Array.isArray(onboarding.questionnaireResponse);
  const questionnaireResponse = !isPointerpro
    ? onboarding.questionnaireResponse
    : [];

  // Intro steps
  const years = profileData.yearsOfExperienceAsCaregiver;
  const intro1 = !!years || parseInt(years) === 0;
  const intro2 = !!profileData.introductionQuestionOriginalInterest;
  const intro3 = !!profileData.introductionQuestionPastExperience;
  const intro4 = !!profileData.introductionQuestionBestStrengths;

  // Skills1 (any general response with text)
  const skills1 = questionnaireResponse.some(
    r => r && r.type === "general" && !!r.responseText
  );

  // Skills2 booleans
  const skills2 = [
    profileData.ableWheelChair,
    profileData.ableTransfer,
    profileData.ableManual,
    profileData.ableLift
  ].every(v => typeof v === "boolean");

  // Helper to validate boolean checkbox fields by key prefix
  const checkBooleanByPrefix = prefix => {
    const keys = Object.keys(profileData).filter(k => k.startsWith(prefix));
    if (keys.length === 0) return false;
    return keys.every(k => typeof profileData[k] === "boolean");
  };

  // Skills3-5 via prefixes
  const skills3 = checkBooleanByPrefix("ableConditions");
  const skills4 = checkBooleanByPrefix("ableTasks");
  const skills5 = checkBooleanByPrefix("ableLanguages");

  // Skills6 booleans
  const skills6 = [
    profileData.ableOvernight,
    profileData.ableCar,
    profileData.ableLiveIn
  ].every(v => typeof v === "boolean");

  // Availability
  const a = profileData.availability;
  const locs = profileData.availabilityLocations;
  const availability =
    !!a &&
    !!locs &&
    (Array.isArray(a) ? a.length > 0 : true) &&
    (Array.isArray(locs) ? locs.length > 0 : true);

  // References
  const refs = questionnaireResponse.filter(
    r => r && r.type === "jobReference"
  );
  const referenceCounts = { ref1: refs.length >= 1, ref2: refs.length === 2 };

  // Screening (require at least 4 screening responses with numeric responseIndex)
  const screeningResponses = questionnaireResponse.filter(
    r => r && r.type === "screening"
  );
  const screeningAll =
    screeningResponses.length >= 4 &&
    screeningResponses.every(r => !isNaN(parseInt(r.responseIndex)));

  // Uploads and questionnaire completed status
  const hasQuestionnaireCompleted =
    Array.isArray(onboarding.screeningStatusDates) &&
    onboarding.screeningStatusDates.some(
      d => d && d.screeningStatus === "questionnaire completed"
    );
  const groupId = stateController.viewGroupId;
  const hasAvatar =
    !!profileData.avatar || !!(fileService.defaultAvatars.group || {})[groupId];
  const uploaded =
    onboardingUpload && onboardingUpload.uploadStatus === "uploaded";
  const uploads = hasQuestionnaireCompleted && hasAvatar && uploaded;

  return (
    intro1 &&
    intro2 &&
    intro3 &&
    intro4 &&
    (isPointerpro || skills1) &&
    skills2 &&
    skills3 &&
    skills4 &&
    skills5 &&
    skills6 &&
    availability &&
    (isPointerpro || referenceCounts.ref1) &&
    (isPointerpro || referenceCounts.ref2) &&
    screeningAll &&
    uploads
  );
};
